export default __webpack_public_path__ + "static/media/yes4.32eb2ac2.png";